import api from './api';

export interface ContactFormData {
  name: string;
  email: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  data?: any;
}

export const contactService = {
  sendMessage: async (formData: ContactFormData): Promise<ContactResponse> => {
    try {
      
      const response = await api.post('/contact', formData);
      
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Erreur lors de l\'envoi du message');
    }
  }
};
